import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-credential-header',
  templateUrl: './credential-header.component.html',
  styleUrls: ['./credential-header.component.css'],
  standalone: true,
})
export class CredentialHeaderComponent implements OnChanges {

  defaultLogo = 'assets/img/logo-white.png';
  imageError = false;

  @Input() headerBackground = "#000000";
  @Input() headerTextColor = "#000000";
  @Input() logoCampaign : string | null = null;;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['logoCampaign']) {
      this.imageError = false;
    }
  }

  onErrorImage() {
    this.imageError = true;
  }
}
